import React, { PropsWithChildren } from "react";

import { StringMap } from "../lib/types";
import { clsx } from "clsx";

type Props = {
  forId?: string;
  inline?: boolean;
  className?: string;
  style?: StringMap<any>;
  srOnly?: boolean;
  onClick?: () => void;
};

const ControlLabel = ({
  children,
  inline,
  className,
  srOnly,
  style,
  forId,
  onClick,
}: PropsWithChildren<Props>) => (
  <label
    htmlFor={forId}
    className={clsx({
      inline,
      "sr-only": srOnly,
      [`${className ? className : ""}`]: className,
    })}
    onClick={onClick}
    style={style}
  >
    {children}
  </label>
);

export default ControlLabel;
